const IconCheckHalf = () => (
  <svg
    width='21'
    height='22.5'
    viewBox='0 0 21 22.5'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <rect y='0.75' width='21' height='21' rx='4.2' fill='#1C6EC9' />
    <path d='M7.35059 11.25H13.6506' stroke='white' strokeWidth='2.1' />
  </svg>
);
export default IconCheckHalf;
